
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import api from "@/services/api.service";
import { RegisterModal, RegisterResult } from "@/store/my-account/types";
import { TimeZone } from "@/store/types";
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

@Component({
	components: {
		"v-select": vSelect,
		scrollbar: VuePerfectScrollbar
	}
})
export default class Signup extends Vue {
	@Getter("accountCreationEnabled") private accountCreationAllowed;
	@Getter("getTimeZones") timeZoneList: TimeZone[];

	@Action getTimeZones: any;

	public loggingIn: boolean = false;
	private errors = [];
	private strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
	private mediumRegex = new RegExp(
		"^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
	);
	private TimeZones = [];

	async created() {
		if (!(await api.getAccountCreationStatus())) {
			this.$router.push("login");
		}

		await this.getTimeZones();

		if (this.timeZoneList) {
			// get timezones and map to the format needed to v-select
			this.TimeZones = this.timeZoneList.map(t => {
				return { timeZoneID: t.timeZoneID, title: t.id };
			});
		}
	}
	private passwordStrenghClass = null;

	private timezoneModel = { id: 35, title: "UTC" };

	private userObject: RegisterModal = {
		Name: null,
		EmailAddress: null,
		Password: null,
		ConfirmPassword: null,
		Telephone: null,
		CompanyName: null,
		CompanyAddress: null,
		TimeZoneId: 35
	};

	private result: RegisterResult = {
		errorMessage: null,
		successful: false
	};

	private validate(registration: RegisterModal) {
		let errors = [];

		if (registration.Name == null || registration.Name.length == 0) {
			errors.push("Your name is required");
		}

		if (
			registration.EmailAddress == null ||
			(registration.EmailAddress && !this.validateEmail(registration.EmailAddress))
		) {
			errors.push("A valid email address is required");
		}

		if (registration.Telephone == null || registration.Telephone.length == 0) {
			errors.push("A contact number is required");
		}

		if (registration.Password == null) {
			errors.push("Password is requried");
		}

		if (
			(registration.Password && registration.ConfirmPassword == null) ||
			(registration.ConfirmPassword && registration.Password && registration.ConfirmPassword != registration.Password)
		) {
			errors.push("Passwords do not match");
		}

		if (
			registration.Password &&
			registration.Password.length > 0 &&
			this.passwordStrenghClass &&
			this.passwordStrenghClass == "Weak"
		) {
			errors.push("A stronger password is required");

			this.validatePassword(registration.Password);
		}

		if (registration.CompanyName == null || registration.CompanyName.length == 0) {
			errors.push("Company name is requried");
		}

		if (registration.CompanyAddress == null || registration.CompanyAddress.length == 0) {
			errors.push("Company address is requried");
		}

		this.errors = errors;
	}

	private validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	private validatePassword(value) {
		if (this.strongRegex.test(value)) {
			this.passwordStrenghClass = "Strong";
		} else if (this.mediumRegex.test(value)) {
			this.passwordStrenghClass = "Medium";
		} else {
			this.passwordStrenghClass = "Weak";
		}
	}

	private async Signup() {
		this.validate(this.userObject);
		if (this.errors.length == 0) {
			this.loggingIn = true;

			this.errors = [];
			this.result = await api.register(this.userObject);

			if (this.result && this.result.successful) {
				this.$router.push("login");
			} else {
				this.errors.push(this.result.errorMessage);
				this.loggingIn = false;
			}
		}
	}

	private setTimezone(value) {
		this.userObject.TimeZoneId = value.timeZoneID;
	}
}
